const Error404 = () => import('@/views/Error404.vue');

const routes = [
  {
    path: '*',
    name: 'error-404',
    component: Error404,
    meta: {
      title: 'Error 404',
    },
  },
];

export default routes;
